import { Component } from '@opten/compiler/metadata/component';
import { hasClass } from '@opten/dom/has-class';
import { debounce } from '@opten/reactive/debounce';
import {
	ScrollMagicController,
	ScrollMagicDesktopController,
	ScrollMagicDesktopModalController,
	ScrollMagicModalController
} from '../main';

declare const ScrollMagic: any;
declare const TweenMax: any;
declare const Linear: any;
@Component({ className: 'js-section-scroll' })
export class SectionScrollComponent {
	private sections: HTMLElement[];
	private scenes = [];

	constructor(private element: HTMLElement) {
		this.sections = Array.from(
			element.querySelectorAll('.js-section-scroll-item')
		) as HTMLElement[];

		this.init();

		window.addEventListener(
			'resize',
			debounce(() => this.init(), 300)
		);
	}

	private init() {
		if (this.scenes && this.scenes.length > 0) {
			this.scenes.forEach(({ scene, triggerElement, tween }) => {
				if (tween) {
					TweenMax.set(triggerElement, { clearProps: 'all' });
					scene.removeTween(true);
				}
				scene.destroy(true);
			});
			this.scenes = [];
		}
		if (this.sections && this.sections.length > 0) {
			const fullSectionScene = new ScrollMagic.Scene({
				triggerElement: this.element,
				triggerHook: 'onLeave',
				duration: () => {
					return this.element.clientHeight;
				}
			})
				//.addIndicators()
				.setClassToggle(this.element, 'is-active');
			this.scenes.push({
				triggerElement: this.element,
				activeOnMobile: true,
				scene: fullSectionScene
			});

			this.sections.forEach((section, i) => {
				const isNumberSection = hasClass(
					section,
					'c-section-scroll-item-number'
				);
				const medias = Array.from(
					section.querySelectorAll('.js-section-scroll-media')
				) as HTMLElement[];
				if (medias && medias.length > 0) {
					medias.forEach((media, i) => {
						if (window.innerWidth >= 768) {
							const mediaScene = new ScrollMagic.Scene({
								triggerElement: section,
								triggerHook: 'onLeave',
								duration: () => {
									return section.clientHeight;
								}
							})
								//.addIndicators()
								.setPin(media, { pushFollowers: false });
							this.scenes.push({
								triggerElement: section,
								activeOnMobile: false,
								scene: mediaScene
							});
						}

						const sibling = isNumberSection
							? null
							: (
									media.closest('[class*="col"')
										.nextElementSibling ||
									media.closest('[class*="col"')
										.previousElementSibling
							  )?.firstElementChild;
						if (sibling) {
							let size = window.innerHeight * 0.5;
							if (sibling.clientHeight < section.clientHeight) {
								size -= sibling.clientHeight / 2;
							}
							if (size < 200) {
								size = 200;
							}
							const tween = TweenMax.fromTo(
								sibling,
								1,
								{
									y: size,
									ease: Linear.easeNone
								},
								{
									y: size > 200 ? 0 : size * -1,
									ease: Linear.easeNone
								}
							);
							const siblingScene = new ScrollMagic.Scene({
								triggerElement: sibling,
								triggerHook: 'onCenter',
								duration: () => {
									return sibling.clientHeight - 100 >
										section.clientHeight
										? sibling.clientHeight
										: section.clientHeight;
								}
							})
								//.addIndicators()
								.setTween(tween);
							this.scenes.push({
								triggerElement: sibling,
								activeOnMobile: true,
								scene: siblingScene,
								tween
							});
						}
					});
				}

				const sectionScene = new ScrollMagic.Scene({
					triggerElement: section,
					triggerHook: 0,
					duration: () => {
						return section.clientHeight;
					}
				})
					//.addIndicators()
					.setClassToggle(section, 'is-at-start');

				this.scenes.push({
					triggerElement: section,
					activeOnMobile: true,
					scene: sectionScene
				});

				const sectionScene2 = new ScrollMagic.Scene({
					triggerElement: section,
					triggerHook: 0.6,
					duration: () => {
						return section.clientHeight;
					}
				})
					//.addIndicators()
					.setClassToggle(section, 'is-at-center');

				this.scenes.push({
					triggerElement: section,
					activeOnMobile: true,
					scene: sectionScene2
				});
			});

			this.handleScenes();
		}
	}

	private handleScenes() {
		if (this.scenes.length > 0) {
			this.scenes.forEach(({ triggerElement, activeOnMobile, scene }) => {
				if (activeOnMobile) {
					scene.addTo(
						triggerElement.closest('.js-modal')
							? ScrollMagicModalController
							: ScrollMagicController
					);
				} else {
					scene.addTo(
						triggerElement.closest('.js-modal')
							? ScrollMagicDesktopModalController
							: ScrollMagicDesktopController
					);
				}
			});
		}
	}
}
